import { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { getNetworkStateAsync } from 'expo-network'

export class MissingNetworkConnectionInterceptor {
    private axiosInstance: AxiosInstance

    constructor(axiosInstance: AxiosInstance) {
        this.axiosInstance = axiosInstance

        this.attachInterceptor()
    }

    private attachInterceptor = (): void => {
        this.axiosInstance.interceptors.request.use(this.onFulfilled)
    }

    private onFulfilled = async (
        config: InternalAxiosRequestConfig
    ): Promise<InternalAxiosRequestConfig> => {
        const networkState = await getNetworkStateAsync()

        if (!networkState.isConnected) {
            if (!config.extras) config.extras = {}

            config.extras.missingNetworkConnection = true
        }

        return config
    }
}
